import PrivateRoute from 'components/app-layout/PrivateRoute';
import AppRouter from 'components/app-layout/Router';

import ErrorLayout from './views/errors/Layout';
import LoginAuditLayout from './views/login-audit/Layout';
import OrganizationLayout from './views/organization/Layout';
import SiteLayout from './views/site/Layout';
import TokenLayout from './views/token/Layout';
import UserLayout from './views/user/Layout';

export default function AdminRoutes() {
  return <AppRouter redirect='/admin/organizations'>
    <PrivateRoute path='/admin/organizations' component={OrganizationLayout} />
    <PrivateRoute path='/admin/sites' component={SiteLayout} />
    <PrivateRoute path='/admin/users' component={UserLayout} />
    <PrivateRoute path='/admin/loginAudit' component={LoginAuditLayout} />
    <PrivateRoute path='/admin/app-error' component={ErrorLayout} />
    <PrivateRoute path='/admin/tokens' component={TokenLayout} />
  </AppRouter>
}
